import { PrincipalModule } from './../principal/principal.module';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanActivateAuthGuard } from '../../core/can-active.authguard';


const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {path: 'home',
  canActivate: [CanActivateAuthGuard],
  loadChildren: '../principal/principal.module#PrincipalModule'},
  { path: 'login',  loadChildren: '../login/login.module#LoginModule' },
  { path: 'erro',  loadChildren: '../erro/erro.module#ErroModule' },
  { path: 'vistoria',
  canActivate: [CanActivateAuthGuard],  loadChildren: '../vistoria/vistoria.module#VistoriaModule' },
  { path: 'laudo',  loadChildren: '../laudos/laudos.module#LaudosModule' },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { enableTracing: false , useHash: true, onSameUrlNavigation: 'reload' }) ],
  exports: [ RouterModule ]
})
export class RotasModule { }



// WEBPACK FOOTER //
// ./src/app/modulos/rotas/rotas.module.ts